let footerExpandBtns = $('footer .footer__column-toggle');

for (let i = 0; i < footerExpandBtns.length; i++) {
    footerExpandBtns[i].addEventListener('click', function (event) {
        event.preventDefault();
        let toggleDiv = footerExpandBtns[i].parentElement.nextElementSibling;
        let columnDiv = footerExpandBtns[i].parentElement.parentElement;
        let btnIcon = footerExpandBtns[i].firstChild;
        if (toggleDiv.classList.contains('show')) {
            toggleDiv.classList.remove('show');
            toggleDiv.ariaExpanded = false;
            btnIcon.classList.add('fa-plus');
            btnIcon.classList.remove('fa-minus');
            columnDiv.classList.remove('selected');
            columnDiv.classList.remove('cn-footer-dashed');
        } else {
            toggleDiv.classList.add('show');
            toggleDiv.ariaExpanded = true;
            btnIcon.classList.remove('fa-plus');
            btnIcon.classList.add('fa-minus');
            columnDiv.classList.add('selected');
            columnDiv.classList.add('cn-footer-dashed');
        }
    });
}
